import {clsx} from 'clsx'
import {twMerge} from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const isNotEmptyAndDefined = value => {
  return value !== undefined && value !== ''
}
export const isObjectNotEmpty = obj => {
  return Object.keys(obj).every(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
}
export const downloadCSVFiles = (csvString, fileName = 'File.csv') => {
  const blob = new Blob([csvString], {type: 'text/csv;charset=utf-8;'})

  const link = document.createElement('a')

  link.download = fileName

  link.href = URL.createObjectURL(blob)

  link.click()

  URL.revokeObjectURL(link.href)
}
export const getDateWithTimeString = () => {
  const date = new Date()
  const isoString = date.toISOString()
  const formattedDate = isoString
    .replace('T', '_')
    .replace(/\.\d{3}Z/, '')
    .replaceAll(':', '')
  return formattedDate
}

export function capitalizeFirst(text) {
  if (!text) return '-'
  const lower = text.toLowerCase()
  return lower.charAt(0).toUpperCase() + lower.slice(1)
}

export function formatAddress(address) {
  if (!address) return '-'

  // Split by comma, trim, remove null/undefined/"null"
  const parts = address
    .split(',')
    .map(part => part && part.trim())
    .filter(part => part && part.toLowerCase() !== 'null')

  if (parts.length === 0) return '-'

  // Capitalize each word in each part
  const capitalize = str => str.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())

  return parts.map(capitalize).join(', ')
}

export function formatDateToYMD(dateString) {
  if (!dateString) return '-'
  return dateString.split('T')[0]
}
